"use strict";

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); //================================================================ 

/** @module std.experimental */
//================================================================

var MultiTreeSet_1 = require("../../base/container/MultiTreeSet");

var _ITreeContainer_1 = require("../../base/container/_ITreeContainer");

var SetElementVector_1 = require("../../base/container/SetElementVector");

var binary_search_1 = require("../../algorithm/binary_search");

var FlatMultiSet =
/** @class */
function (_super) {
  __extends(FlatMultiSet, _super);

  function FlatMultiSet() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    var _this = // INITIALIZATION
    _super.call(this, function (thisArg) {
      return new SetElementVector_1.SetElementVector(thisArg);
    }) || this; // OVERLOADINGS


    _ITreeContainer_1._Construct.apply(void 0, __spread([_this, FlatMultiSet, function (comp) {
      _this.key_comp_ = comp;
    }], args));

    return _this;
  }
  /**
   * @inheritDoc
   */


  FlatMultiSet.prototype.swap = function (obj) {
    var _a, _b; // SWAP CONTENTS


    _a = __read([obj.data_, this.data_], 2), this.data_ = _a[0], obj.data_ = _a[1];

    SetElementVector_1.SetElementVector._Swap_associative(this.data_, obj.data_); // SWAP COMPARATORS


    _b = __read([obj.key_comp_, this.key_comp_], 2), this.key_comp_ = _b[0], obj.key_comp_ = _b[1];
  };
  /* ---------------------------------------------------------
      ACCESSORS
  --------------------------------------------------------- */

  /**
   * @inheritDoc
   */


  FlatMultiSet.prototype.nth = function (index) {
    return this.data_.nth(index);
  };
  /**
   * @inheritDoc
   */


  FlatMultiSet.prototype.key_comp = function () {
    return this.key_comp_;
  };
  /**
   * @inheritDoc
   */


  FlatMultiSet.prototype.lower_bound = function (key) {
    return binary_search_1.lower_bound(this.begin(), this.end(), key, this.value_comp());
  };
  /**
   * @inheritDoc
   */


  FlatMultiSet.prototype.upper_bound = function (key) {
    return binary_search_1.upper_bound(this.begin(), this.end(), key, this.value_comp());
  };
  /* ---------------------------------------------------------
      POST-PROCESS
  --------------------------------------------------------- */

  /**
   * @hidden
   */


  FlatMultiSet.prototype._Handle_insert = function (_a, _b) {};
  /**
   * @hidden
   */


  FlatMultiSet.prototype._Handle_erase = function (_a, _b) {};

  return FlatMultiSet;
}(MultiTreeSet_1.MultiTreeSet);

exports.FlatMultiSet = FlatMultiSet;

(function (FlatMultiSet) {
  // BODY
  FlatMultiSet.Iterator = SetElementVector_1.SetElementVector.Iterator;
  FlatMultiSet.ReverseIterator = SetElementVector_1.SetElementVector.ReverseIterator; // BODY

  FlatMultiSet.iterator = FlatMultiSet.Iterator;
  FlatMultiSet.reverse_iterator = FlatMultiSet.ReverseIterator;
})(FlatMultiSet = exports.FlatMultiSet || (exports.FlatMultiSet = {}));

exports.FlatMultiSet = FlatMultiSet;
exports.flat_multiset = FlatMultiSet;